import React, { useState } from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

export default function Demo() {
  const [phone, setPhone] = useState("");

  return (
    <div style={{ width: "300px" }}>
      <h2>Demo</h2>
      <PhoneInput
        defaultCountry="in"
        value={phone}
        onChange={(phone) => setPhone(phone)}
        inputStyle={{
          backgroundColor: "#222",   // dark mode
          color: "#fff",             // text white
        }}
        countrySelectorStyleProps={{
          buttonStyle: {
            backgroundColor: "#222",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}
